import script from "./ContestBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestBox.vue?vue&type=script&setup=true&lang=js"

import "./ContestBox.vue?vue&type=style&index=0&id=eab8f6f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eab8f6f4"]])

export default __exports__